import * as React from 'react';

import { ConnectedGuidedTourHome } from './components/GuidedTourHome';
import actionCreators from './service/GuidedTour.actions';
import { guideTourReducer, REDUCER_KEY } from './service/GuidedTour.reducer';
import { guidedTourSaga } from './service/GuidedTour.saga';

export { showGuidedTour } from './service/GuidedTour.actions';

export interface GuidedTourHomeRootComponentProps {
	children: React.ReactElement;
}

export function GuidedTourHomeRootComponent({
	children,
}: GuidedTourHomeRootComponentProps): React.ReactElement {
	return (
		<>
			<ConnectedGuidedTourHome />
			{children}
		</>
	);
}

export const GuidedTourModule = {
	id: 'tdc:guidedTour',
	actionCreators,
	saga: guidedTourSaga,
	RootComponent: GuidedTourHomeRootComponent,
	reducer: {
		inventory: {
			[REDUCER_KEY]: guideTourReducer,
		},
	},
};
